import { render, staticRenderFns } from "./VisitedProfile.vue?vue&type=template&id=73ccb60d&"
import script from "./VisitedProfile.vue?vue&type=script&lang=js&"
export * from "./VisitedProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports